import { r2Fetch } from './client';

interface R2BucketListResponse {
  buckets: { name: string }[];
}

export async function r2BucketList(): Promise<string[]> {
  const response = await r2Fetch<R2BucketListResponse>('/rpc/r2_bucket_list');
  return response.buckets.map((bucket) => bucket.name);
}
